/* ============================================================
   Announcement Bar JS (announcement-bar.liquid)
   ============================================================ */
(function () {
  'use strict';

  /* Pause marquee on hover */
  const annBar = qs('.announcement-bar__content');
  if (annBar) {
    annBar.addEventListener('mouseenter', () => { annBar.style.animationPlayState = 'paused'; });
    annBar.addEventListener('mouseleave', () => { annBar.style.animationPlayState = 'running'; });
  }

  /* Announcement bar slider */
  const bar = qs('.announcement-bar');
  if (!bar) return;
  const slides = Array.from(bar.querySelectorAll('.announcement-bar__slide'));
  if (slides.length <= 1) return;

  let current = 0;

  function showSlide(idx) {
    slides[current].classList.remove('is-active');
    current = (idx + slides.length) % slides.length;
    slides[current].classList.add('is-active');
  }

  const prevBtn = bar.querySelector('.js-ann-prev');
  const nextBtn = bar.querySelector('.js-ann-next');
  if (prevBtn) prevBtn.addEventListener('click', () => showSlide(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => showSlide(current + 1));

  /* Sync with hero slider; fallback to standalone 6s timer if no hero */
  if (document.querySelector('.hero-slideshow')) {
    document.addEventListener('heroSlide', () => showSlide(current + 1));
  } else {
    setInterval(() => showSlide(current + 1), 6000);
  }
})();
